import { Component, OnInit, Input } from '@angular/core';
import { Card } from '../interfaces/card.interface';
import { Comment } from '../interfaces/comment.interface';
import { MatDialog } from '@angular/material/dialog';
import { CardStandardDialogComponent } from '../card-standard-dialog/card-standard-dialog.component';
import { Vote } from '../interfaces/vote.interface';
import { FirebaseService } from '../services/firebase.service';

@Component({
  selector: 'app-card-standard',
  templateUrl: './card-standard.component.html',
  styleUrls: ['./card-standard.component.css']
})
export class CardStandardComponent implements OnInit {
  @Input() card: Card;
  @Input() comments: Comment[];
  @Input() votes: Vote[];

  constructor(public dialog: MatDialog, public firebaseService: FirebaseService) {
  }

  ngOnInit(): void {
  }

  openCardModal(): void {
    event.stopPropagation();
    this.dialog.open(CardStandardDialogComponent, {
      data: { card: this.card, comments: this.comments, votes: this.votes },
      width: '30rem'
    });
  }

  vote(): void {
    event.stopPropagation();
    const newVote: Vote = {
      userId: this.firebaseService.getUserId(),
      cardId: this.card.id
    };
    if ((this.votes.filter(vote => vote.userId === newVote.userId)).length > 0) {
      this.firebaseService.deleteVote(newVote);
      this.votes.splice(this.votes.indexOf(newVote, 0), 1);
    } else {
      this.firebaseService.putVote(newVote);
      this.votes.push(newVote);
    }
  }

  /*
  * Deprecated
  */
  star(): void {}
}
